<template>
  <div class="body_monban" >
    <el-tabs  style="height: 200px;" v-model="activeName">
    <el-tab-pane label="车型维护" name="cheXing_Weihu"><cheXingWeihu></cheXingWeihu></el-tab-pane>
  </el-tabs>

  </div>
</template>
<style>
.body_moban{
  padding-top: 100px;
}
</style>
<script>

import cheXingWeihu from '../../tongyong/cheXingWeihu.vue' 

// import macType from './macType.vue';
export default {
  components: {
     cheXingWeihu: cheXingWeihu
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'cheXing_Weihu' 
  
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  },
  methods: {
    getCarTypeSelectedUid(typeId) {
    //  console.log(880, typeId)
    }
  }
}
</script>
